import { api, getApiBaseUrl } from './client';
import type { AudioFile } from '@pomodingo/api-client';

export { getApiBaseUrl };
export type { AudioFile };

export async function apiFetch(path: string, init: RequestInit = {}): Promise<Response> {
  return api.http.fetch(path, init);
}

export async function apiJson<T>(path: string, init?: RequestInit): Promise<T> {
  return api.http.json<T>(path, init);
}

export async function listAudioFiles(): Promise<AudioFile[]> {
  return api.audio.list();
}

export async function fetchAudioContent(storagePath: string): Promise<ArrayBuffer> {
  return api.audio.fetchContentByPath(storagePath);
}

export async function getAudioPlaybackUrl(storagePath: string): Promise<string> {
  const buffer = await fetchAudioContent(storagePath);
  return URL.createObjectURL(new Blob([buffer]));
}

export async function deleteAudioFile(id: string): Promise<void> {
  return api.audio.delete(id);
}

export async function uploadAudioFile(file: File): Promise<AudioFile> {
  return api.audio.upload(file);
}
